/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookClosedIcon20Light = forwardRef('BookClosedIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.5 5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1h-6Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.998 1a3 3 0 0 0-3 3v12a2 2 0 0 0 2 2h10.504a.5.5 0 1 0 0-1H4.998a1 1 0 1 1 0-2h9.254a1.75 1.75 0 0 0 1.75-1.75V2.75A1.75 1.75 0 0 0 14.252 1H5.998Zm-1 13a1.99 1.99 0 0 0-1 .268V4a2 2 0 0 1 2-2h8.254a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-.75.75H4.998Z" })));
});
